var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',[_c('b-alert',{attrs:{"show":"","variant":"warning"}},[_vm._v(_vm._s(_vm.$t("seite_nicht_gefunden.module_nicht_gefunden")))])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }